(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gpg-product-notice"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gpg-product-notice')) {
  customElements.define('gpg-product-notice', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.items = Array.from(this.querySelectorAll('[data-notice-item]'));
      this.content = this.querySelector('[data-notice-content]');
      this.catalog = this.dataset.catalog === 'true';
      this.pages = Math.max(1, Number(this.dataset.catalogPages) || 1);
      if ((!this.items.length && !this.catalog) || !this.content) return;
      this.interval = Math.max(60000, Number(this.dataset.interval) || 180000);
      this.duration = Math.max(6000, Number(this.dataset.duration) || 12000);
      this.limit = Math.max(1, Number(this.dataset.limit) || 3);
      this.preview = this.dataset.preview === 'true';
      this.storageKey = 'gpg-product-notice-v2';
      this.state = { shown: 0, nextAt: Date.now() + this.interval, dismissed: false, seen: [] };
      if (!this.preview) {
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || sessionStorage.getItem('gpg-product-notice-v1'));
          if (saved && Number.isFinite(saved.nextAt) && Number.isInteger(saved.shown) && saved.shown >= 0) {
            this.state = { shown: saved.shown, nextAt: saved.nextAt, dismissed: saved.dismissed === true, seen: Array.isArray(saved.seen) ? saved.seen.filter(id => typeof id === 'string').slice(-50) : [] };
          }
        } catch {}
        this.persist();
      }
      const options = { signal: this.abort.signal };
      this.querySelector('[data-notice-close]').addEventListener('click', () => this.dismiss(), options);
      this.addEventListener('keydown', event => { if (event.key === 'Escape') this.dismiss(); }, options);
      this.addEventListener('pointerenter', () => clearTimeout(this.hideTimer), options);
      this.addEventListener('pointerleave', () => { if (!this.contains(document.activeElement)) this.armHide(); }, options);
      this.addEventListener('focusin', () => clearTimeout(this.hideTimer), options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget) && !this.matches(':hover')) this.armHide(); }, options);
      if (this.preview) {
        document.addEventListener('shopify:section:select', event => { if (event.detail.sectionId === this.dataset.sectionId) this.show(); }, options);
        this.show();
        return;
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.hide();
        else this.schedule();
      }, options);
      this.schedule();
    }
    persist() {
      if (this.preview) return;
      try { sessionStorage.setItem(this.storageKey, JSON.stringify(this.state)); } catch {}
    }
    schedule() {
      clearTimeout(this.showTimer);
      if (this.preview || this.state.dismissed || this.state.shown >= this.limit) return;
      this.showTimer = setTimeout(() => this.show(), Math.max(0, this.state.nextAt - Date.now()));
    }
    choose(items) {
      const available = items.filter(item => item.dataset.productId && item.dataset.productId !== this.dataset.currentProduct && !this.state.seen.includes(item.dataset.productId));
      return available[Math.floor(Math.random() * available.length)];
    }
    async selectItem() {
      if (this.catalog) {
        const tried = new Set();
        for (let attempt = 0; attempt < Math.min(3, this.pages); attempt += 1) {
          let page = Math.floor(Math.random() * this.pages) + 1;
          while (tried.has(page)) page = page % this.pages + 1;
          tried.add(page);
          const controller = new AbortController();
          const cancel = () => controller.abort();
          this.abort.signal.addEventListener('abort', cancel, { once: true });
          const timeout = setTimeout(cancel, 8000);
          try {
            const url = new URL(this.dataset.catalogUrl, window.location.origin);
            if (url.origin !== window.location.origin) break;
            url.searchParams.set('page', String(page));
            const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
            if (!response.ok) continue;
            const pageDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
            const catalog = pageDocument.querySelector('[data-notice-catalog]');
            if (!catalog) break;
            this.pages = Math.max(1, Number(catalog.dataset.pages) || this.pages);
            const item = this.choose(Array.from(catalog.querySelectorAll('template[data-notice-item]')));
            if (item) return item;
          } catch {
            if (this.abort.signal.aborted) return;
          } finally {
            clearTimeout(timeout);
            this.abort.signal.removeEventListener('abort', cancel);
          }
        }
      }
      return this.choose(this.items);
    }
    blocked() {
      return document.hidden || Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], cart-drawer.active')).some(element => {
        const style = getComputedStyle(element);
        return element.getClientRects().length > 0 && style.visibility !== 'hidden' && style.opacity !== '0';
      });
    }
    async show() {
      if (!this.isConnected || this.loading) return;
      if (!this.preview) {
        if (this.state.dismissed || this.state.shown >= this.limit) return;
        if (this.blocked() || !this.hidden) {
          this.showTimer = setTimeout(() => this.show(), 15000);
          return;
        }
      }
      this.loading = true;
      const item = await this.selectItem();
      this.loading = false;
      if (!this.isConnected || this.abort.signal.aborted || this.state.dismissed) return;
      if (!item || (!this.preview && this.blocked())) {
        this.state.nextAt = Date.now() + this.interval;
        this.persist();
        this.schedule();
        return;
      }
      this.content.replaceChildren(item.content.cloneNode(true));
      this.hidden = false;
      this.state.seen.push(item.dataset.productId);
      if (!this.preview) {
        this.state.shown += 1;
        this.state.nextAt = Date.now() + this.interval;
        this.persist();
        this.armHide();
        this.schedule();
      }
    }
    armHide() {
      clearTimeout(this.hideTimer);
      if (!this.preview && !this.hidden) this.hideTimer = setTimeout(() => this.hide(), this.duration);
    }
    hide() {
      clearTimeout(this.hideTimer);
      this.hidden = true;
    }
    dismiss() {
      this.hide();
      clearTimeout(this.showTimer);
      if (this.preview) return;
      this.state.dismissed = true;
      this.persist();
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.showTimer);
      clearTimeout(this.hideTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
